import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { reLeaseFeeCalcClassConfig } from './ReLeaseFeeCalcClass.name';

/** 再リース料計算区分のENUM */
enum ReLeaseFeeCalcClass {
  /** 基本リース料年額の1/10 */
  reLeaseFeeCalcOneTen = '1',
  /** 基本リース料年額の1/12 */
  reLeaseFeeCalcOneTwelve = '2',
  /** 手入力 */
  reLeaseFeeCalcManualInput = '3',
  /** 未設定 */
  unSetting = '9',
}

const reLeaseCalcClassMap = new Map([
  ['1', ReLeaseFeeCalcClass.reLeaseFeeCalcOneTen],
  ['2', ReLeaseFeeCalcClass.reLeaseFeeCalcOneTwelve],
  ['3', ReLeaseFeeCalcClass.reLeaseFeeCalcManualInput],
  ['9', ReLeaseFeeCalcClass.unSetting],
]);

const rawValueToReLeaseCalcClass = (rawValue: string) => {
  return rawValueToEnumWithDefault(reLeaseCalcClassMap, ReLeaseFeeCalcClass.unSetting)(rawValue);
};

const reLeaseCalcClassToDisplay = enumToNameWithDefault(ReLeaseFeeCalcClass, reLeaseFeeCalcClassConfig);

const reLeaseCalcClassToServer = (value: ReLeaseFeeCalcClass) => {
  switch (value) {
    case ReLeaseFeeCalcClass.reLeaseFeeCalcOneTen:
      return 'RE_LEASE_CALC_ONE_TEN';
    case ReLeaseFeeCalcClass.reLeaseFeeCalcOneTwelve:
      return 'RE_LEASE_CALC_ONE_TWELVE';
    case ReLeaseFeeCalcClass.reLeaseFeeCalcManualInput:
      return 'RE_LEASE_CALC_MANUAL_INPUT';
    case ReLeaseFeeCalcClass.unSetting:
      return 'UN_SET';
  }
};

const reLeaseCalcClassToDisplayWithPrefix = enumToNameWithDefault(
  ReLeaseFeeCalcClass,
  reLeaseFeeCalcClassConfig,
  true,
);

export {
  ReLeaseFeeCalcClass,
  rawValueToReLeaseCalcClass,
  reLeaseCalcClassToDisplay,
  reLeaseCalcClassToDisplayWithPrefix,
  reLeaseCalcClassToServer,
};
